module.exports = __webpack_public_path__ + "static/media/banner-keyman@2x.b2e4d1ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-keyman@2x.png
// module id = 1255
// module chunks = 1